import moment from 'moment';

const decimal = value => new Intl.NumberFormat('de-DE', { maximumFractionDigits: 2 }).format(value);

const amount = (value) => {
  if (!value) {
    return value;
  }

  if (typeof value === 'number') {
    return decimal(value);
  }

  const number = value
    .toString()
    .replace(/[^\d,]/g, '')
    .replace(',', '.');

  const formattedNumber = decimal(number);

  if (number.substring(number.length - 1, number.length) === '.') {
    return `${formattedNumber}${','}`;
  }

  return formattedNumber;
};

const date = value => moment(value).format('DD.MM.YYYY');
const shortDate = value => moment(value).format('DD.MM.YY');
const isDate = value => moment.parseZone(value).format('DD-MM-YYYY');

const any = (value) => {
  switch (typeof value) {
    case 'number':
      return decimal(value);
    case 'object':
      return value instanceof Date ? date(value) : value;
    default:
      return moment(value, 'YYYY-MM-DDTHH:mm:ss', true).isValid() ||
        moment(value, 'YYYY-MM-DDTHH:mm:ss.SSSSSS', true).isValid()
        ? date(value)
        : value;
  }
};

export const accountNumber = value =>
  `${value.slice(0, 4)}-${value.slice(4, 6)}-${value.slice(6, 12)}`;

const format = {
  decimal,
  amount,
  date,
  accountNumber,
  shortDate,
  isDate,
  any,
  value: any,
};

export default format;
